import angular from 'angular';

/**
 * Контекстная помощь: значок «?» с кратким пояснением параметра при наведении или фокусе.
 * Использование: <shb-help text="Пояснение параметра"></shb-help>
 * Не предназначен для очевидных элементов интерфейса — только для сложных настроек.
 */
export const shbHelp = {
  bindings: {
    text: '@',
    placement: '@?',
  },
  template: `
    <button
      type="button"
      class="shb-help"
      aria-label="Справка"
      uib-tooltip="{{ ::$ctrl.text }}"
      tooltip-placement="{{ ::$ctrl.placement || 'top' }}"
      tooltip-class="shb-help__tooltip"
      tooltip-trigger="'mouseenter focus click'"
      tooltip-append-to-body="true"
    >
      <i class="fa fa-question" aria-hidden="true"></i>
    </button>`,
};

export default angular.module('shbdeployer.components.help', []).component('shbHelp', shbHelp).name;
